import React from 'react';
import styled from 'styled-components';
import Navigation from './Navigation';
import Footer from './Footer';
import FloatingBubbles from './FloatingBubbles';
import WhatsAppButton from './WhatsAppButton';

// Allows bubble layer (z-index: 3, fixed) to float above page backgrounds
const ContentStack = styled.div`
  position: relative;
  z-index: 1;
`;

const Main = styled.main`
  min-height: 100vh;
`;

function Layout({ children }) {
  return (
    <>
      <FloatingBubbles />
      <ContentStack>
        <Navigation />
        <Main>{children}</Main>
        <Footer />
      </ContentStack>
      <WhatsAppButton />
    </>
  );
}

export default Layout;
